"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var react_1 = __importDefault(require("react"));
var Input = function (_a) {
    var title = _a.title, _b = _a.warning, warning = _b === void 0 ? false : _b, _c = _a.defaultValue, defaultValue = _c === void 0 ? undefined : _c, _d = _a.value, value = _d === void 0 ? undefined : _d, name = _a.name, placeholder = _a.placeholder, _e = _a.type, type = _e === void 0 ? 'text' : _e, _f = _a.disabled, disabled = _f === void 0 ? false : _f, customClasses = _a.customClasses, _g = _a.multiline, multiline = _g === void 0 ? false : _g, rows = _a.rows, _h = _a.autoFocus, autoFocus = _h === void 0 ? false : _h, _j = _a.readOnly, readOnly = _j === void 0 ? false : _j, _k = _a.required, required = _k === void 0 ? false : _k, maxLength = _a.maxLength, minLength = _a.minLength, onChange = _a.onChange, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown, onBlur = _a.onBlur, onFocus = _a.onFocus, onClick = _a.onClick, reference = _a.reference;
    return (react_1.default.createElement("div", { className: "axxes-input__container " + customClasses },
        react_1.default.createElement("div", { className: "axxes-input__field " + (warning && '-error') },
            title && (react_1.default.createElement("label", { htmlFor: name, className: "" + (value || value !== '' ? 'label--float' : '') },
                title,
                required && '*')),
            !multiline && (react_1.default.createElement("input", { defaultValue: defaultValue, ref: reference, className: "input", name: name, value: value && value, autoFocus: autoFocus, onChange: function (e) {
                    e.persist();
                    onChange && onChange(e);
                }, placeholder: placeholder, type: type, disabled: disabled, readOnly: readOnly, maxLength: maxLength, minLength: minLength, onBlur: function (e) {
                    e.persist();
                    onBlur && onBlur(e);
                }, onKeyUp: function (e) {
                    e.persist();
                    onKeyUp && onKeyUp(e);
                }, onFocus: function (e) {
                    e.persist();
                    onFocus && onFocus(e);
                }, onKeyDown: function (e) {
                    e.persist();
                    if (onKeyDown) {
                        onKeyDown(e);
                    }
                    if ((e === null || e === void 0 ? void 0 : e.key) === 'Enter') {
                        e.preventDefault();
                    }
                }, onClick: onClick })),
            multiline && (react_1.default.createElement("textarea", { defaultValue: defaultValue, className: 'input', name: name, ref: reference, rows: rows, placeholder: placeholder, autoFocus: autoFocus, value: value && value, onChange: function (e) {
                    e.persist();
                    onChange && onChange(e);
                }, maxLength: maxLength, readOnly: readOnly, minLength: minLength, onBlur: function (e) {
                    e.persist();
                    onBlur && onBlur(e);
                }, onKeyUp: function (e) {
                    e.persist();
                    onKeyUp && onKeyUp(e);
                }, onFocus: function (e) {
                    e.persist();
                    onFocus && onFocus(e);
                }, onKeyDown: function (e) {
                    e.persist();
                    if (onKeyDown) {
                        onKeyDown(e);
                    }
                }, onClick: onClick })),
            react_1.default.createElement("div", { className: 'axxes-input__warning' }))));
};
exports.Input = Input;
